interface SubtitleProps {
    subtitle: string;
    subtitleDataCy: string;
}

export const getBankMessageSubtitle = (
    isSenderShown: boolean,
    from: string,
    subject: string,
): SubtitleProps => {
    if (isSenderShown) {
        return {
            subtitle: `${from} · ${subject}`,
            subtitleDataCy: 'sender-and-subject',
        };
    }

    return {
        subtitle: subject,
        subtitleDataCy: 'subject',
    };
};
